export default "__VITE_ASSET__DsyhdmZT__"